import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getClientCancellationReasonListSaga = createAction(
  "GET_CLIENT_CANCELLATION_REASON",
  ({
    payload,
    params,
  }: SagaActionParams<Type.ClientCancellationReasonDto[]>) => ({
    payload,
    url: "/api/admin/adminclientcancellationreasons" + (params ? params : ""),
  })
);
export const getClientCancellationReasonDetailsSaga = createAction(
  "GET_CLIENT_CANCELLATION_REASON_DETAILS",
  ({
    payload,
    id,
  }: SagaActionParams<Type.ClientCancellationReasonDetailDto>) => ({
    payload,
    url: "/api/admin/adminclientcancellationreasons/" + id,
  })
);
export const createClientCancellationReasonSaga = createAction(
  "CREATE_CLIENT_CANCELLATION_REASON",
  ({ payload, body }: SagaActionParams<Type.ClientCancellationReasonDto>) => ({
    payload,
    url: "/api/admin/adminclientcancellationreasons",
    body,
  })
);
export const updateClientCancellationReasonSaga = createAction(
  "UPDATE_CLIENT_CANCELLATION_REASON",
  ({
    payload,
    id,
    body,
  }: SagaActionParams<Type.ClientCancellationReasonDto>) => ({
    payload,
    url: "/api/admin/adminvat/" + id,
    body,
  })
);
export const deleteClientCancellationReasonSaga = createAction(
  "DELETE_CLIENT_CANCELLATION_REASON",
  ({ payload, id }: SagaActionParams<Type.ClientCancellationReasonDto>) => ({
    payload,
    url: "/api/admin/adminclientcancellationreasons/" + id,
  })
);

const adminclientcancellationreasonsSaga = [
  takeLatest<any>(
    getClientCancellationReasonListSaga.toString(),
    (payload: SagaGenericParams<Type.ClientCancellationReasonDto[]>) =>
      getSaga<Type.ClientCancellationReasonDto[]>(payload)
  ),
  takeLatest<any>(
    getClientCancellationReasonDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.ClientCancellationReasonDetailDto>) =>
      getSaga<Type.ClientCancellationReasonDetailDto>(payload)
  ),
  takeLatest<any>(
    createClientCancellationReasonSaga.toString(),
    (payload: SagaGenericParams<Type.ClientCancellationReasonDto>) =>
      postSaga<Type.ClientCancellationReasonDto>(payload)
  ),
  takeLatest<any>(
    updateClientCancellationReasonSaga.toString(),
    (payload: SagaGenericParams<Type.ClientCancellationReasonDto>) =>
      putSaga<Type.ClientCancellationReasonDto>(payload)
  ),
  takeLatest<any>(
    deleteClientCancellationReasonSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.ClientCancellationReasonDto>(payload)
  ),
];

export default adminclientcancellationreasonsSaga;
